/* Creazione dei Marker su mappa attivati dopo aver scelto i punti di partenza o arrivo nell infopopup */

import { useLeaflet } from "react-leaflet";
import { connect } from "react-redux";
import { useEffect } from "react";
import L from "leaflet";
import startFlag from './start.png'
import finishFlag from './finish.png'
import { selectNewMarkerStart2, selectNewMarkerEnd2} from '../../redux'

const DrawerMarkerClick = (props) => {
    const { map } = useLeaflet();
    const drawImage = (image) => {
        var iconStart = L.icon({
          iconUrl: image,
          iconSize: [30, 30],
          iconAnchor:   [15  , 35],
          popupAnchor:  [0, -35]
        });
    return iconStart
}

//Rimozione Layer
const removeOldLayer = (string) => {
    map.eachLayer(element => {
      if ( element.options.nome === string ) {
        try {
          element.removeFrom(map) 
        }
        catch(e) { 
        }
      }
    });
  }

    useEffect(()=>{
       
        try { 
          if(props.markerStart2.markerStart2){
            removeOldLayer("markerStart")
            const start = [props.markerStart2.markerStart2.lat,props.markerStart2.markerStart2.lng]
            
            const startMarker = L.marker(start,{icon: drawImage(startFlag),nome: "markerStart"})
            startMarker.addTo(map)          
            
          }
        } catch (error) {
            
        }
       
    },[props.markerStart2])

    useEffect(()=>{
        try { 
          if(props.markerEnd2.markerEnd2){
              removeOldLayer("markerEnd")
              const end = [props.markerEnd2.markerEnd2.lat,props.markerEnd2.markerEnd2.lng]
              const endMarker = L.marker(end,{icon: drawImage(finishFlag),nome: "markerEnd"})
              endMarker.addTo(map)
              
          }
     } catch (error){

     }
    },[props.markerEnd2])
    return null;
}

const mapStateToProps = state => {
    return {
        markerStart2: state.markerStart2,
        markerEnd2: state.markerEnd2
        
    }
  }

export default connect(mapStateToProps)(DrawerMarkerClick);